import { USER_UPGRADE_CLEAR } from "@/constants/constants";
import { createProviderObject } from "@/sagas/normalizers/tvNormalizer";
import { removeDuplicateCardsById } from "@/utils/dataHandlers/TvDataHandler";
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  /* THIRD PARTIES LIST */
  GET_THIRDSERVICES_BEGINS: "THIRDS/GET_THIRDSERVICES_BEGINS",
  GET_THIRDSERVICES_SUCCESS: "THIRDS/GET_THIRDSERVICES_SUCCESS",
  GET_THIRDSERVICES_SUCCESS2: "THIRDS/GET_THIRDSERVICES_SUCCESS2",
  GET_THIRDSERVICES_FAILURE: "THIRDS/GET_THIRDSERVICES_FAILURE",
  GET_THIRDSERVICES_FETCHED: "THIRDS/GET_THIRDSERVICES_FETCHED",

  /* THIRD PARTIES DELETE */
  DELETE_THIRDSERVICES_RESET: "THIRDS/DELETE_THIRDSERVICES_RESET",
  DELETE_THIRDSERVICES_BEGINS: "THIRDS/DELETE_THIRDSERVICES_BEGINS",
  DELETE_THIRDSERVICES_SUCCESS: "THIRDS/DELETE_THIRDSERVICES_SUCCESS",
  DELETE_THIRDSERVICES_FAILURE: "THIRDS/DELETE_THIRDSERVICES_FAILURE",

  /* THIRD PARTIES ADD */
  ADD_THIRDSERVICES_BEGINS: "THIRDS/ADD_THIRDSERVICES_BEGINS",
  ADD_THIRDSERVICES_SUCCESS: "THIRDS/ADD_THIRDSERVICES_SUCCESS",
  ADD_THIRDSERVICES_FAILURE: "THIRDS/ADD_THIRDSERVICES_FAILURE",
  THIRDSERVICES_RESET: "THIRDS/THIRDSERVICES_RESET",

  /* Get URL FOR CS */
  GOTO_ALEJANDRA_PAGE_SUCCESS: "THIRDS/GOTO_ALEJANDRA_PAGE_SUCCESS",
  GOTO_ALEJANDRA_PAGE_BEGINS: "GOTO_ALEJANDRA_PAGE_BEGINS",
  GOTO_ALEJANDRA_PAGE_FAILURE: "GOTO_ALEJANDRA_PAGE_FAILURE",
  /* NETLIX */
  GET_NETFLIX_SUCCESS: "THIRDS/GET_NETFLIX_SUCCESS",
  GET_NETFLIX_BEGINS: "THIRDS/GET_NETFLIX_BEGINS",
  GET_NETFLIX_FAILURE: "THIRDS/GET_NETFLIX_FAILURE",
  CHANGE_NETFLIX_STATE: "THIRDS/CHANGE_NETFLIX_STATE",

  /* DISNEY */
  GET_DISNEY_COMPATIBILITY: "THIRDS/GET_DISNEY_COMPATIBILITY",
  GET_DISNEY_COMPATIBILITY_SUCCESS: "THIRDS/GET_DISNEY_COMPATIBILITY_SUCCESS",
  GET_DISNEY_COMPATIBILITY_FAILURE: "THIRDS/GET_DISNEY_COMPATIBILITY_FAILURE",

  GET_DISNEY_ACTIVATION: "THIRDS/GET_DISNEY_ACTIVACTION",
  CHANGE_STATUS_DISNEY_ACTIVATION: "THIRDS/CHANGE_STATUS_DISNEY_ACTIVATION",

  /* REDIRECT ACTION FOR UNLOGED CLIENTS */
  GOTO_CS_PAGE_BEGINS: "THIRDS/GOTO_CS_PAGE_BEGINS",
  GOTO_CS_PAGE_SUCCESS: "THIRDS/GOTO_CS_PAGE_SUCCESS",
  GOTO_CS_PAGE_FAILURE: "THIRDS/GOTO_CS_PAGE_FAILURE",
  /* GET ALEJANDRA URL */
  GET_URL_ALEJANDRA_BEGINS: "THIRDS/GET_URL_ALEJANDRA_BEGINS",
  GET_URL_ALEJANDRA_SUCCESS: "THIRDS/GET_URL_ALEJANDRA_SUCCESS",
  GET_URL_ALEJANDRA_FAILURE: "THIRDS/GET_URL_ALEJANDRA_FAILURE",

  /* PROVIDER COMPATIBILITY */
  GET_PROVIDER_COMPATIBILITY_BEGINS: "GET_PROVIDER_COMPATIBILITY_BEGINS",
  GET_PROVIDER_COMPATIBILITY_SUCCESS: "GET_PROVIDER_COMPATIBILITY_SUCCESS",
  GET_PROVIDER_COMPATIBILITY_FAILURE: "GET_PROVIDER_COMPATIBILITY_FAILURE",

  /* PROVIDER COMPATIBILITY CAPA */
  GET_NEW_PROVIDER_COMPATIBILITY_BEGINS: "GET_NEW_PROVIDER_COMPATIBILITY_BEGINS",
  GET_NEW_PROVIDER_COMPATIBILITY_SUCCESS: "GET_NEW_PROVIDER_COMPATIBILITY_SUCCESS",
  GET_NEW_PROVIDER_COMPATIBILITY_FAILURE: "GET_NEW_PROVIDER_COMPATIBILITY_FAILURE",

  /* PROVIDER STATUS */
  GET_PROVIDER_STATUS_BEGINS: "GET_PROVIDER_STATUS_BEGINS",
  GET_PROVIDER_STATUS_SUCCESS: "GET_PROVIDER_STATUS_SUCCESS",
  GET_PROVIDER_STATUS_FAILURE: "GET_PROVIDER_STATUS_FAILURE",

  // SMART WIFI DEVICES
  GET_SMART_WIFI_DEVICES_BEGINS: "THIRDS/GET_SMART_WIFI_DEVICES_BEGINS",
  GET_SMART_WIFI_DEVICES_SUCCESS: "THIRDS/GET_SMART_WIFI_DEVICES_SUCCESS",
  GET_SMART_WIFI_DEVICES_FAILURE: "THIRDS/GET_SMART_WIFI_DEVICES_FAILURE",
  // SMART WIFI OTHERS DETAILS
  GET_SMART_WIFI_OTHERS_DETAILS_BEGINS:
    "THIRDS/GET_SMART_WIFI_OTHERS_DETAILS_BEGINS",
  GET_SMART_WIFI_OTHERS_DETAILS_SUCCESS:
    "THIRDS/GET_SMART_WIFI_OTHERS_DETAILS_SUCCESS",
  GET_SMART_WIFI_OTHERS_DETAILS_FAILURE:
    "THIRDS/GET_SMART_WIFI_OTHERS_DETAILS_FAILURE",
  // SMART WIFI MANAGEMENT
  SMART_WIFI_MANAGEMENT_BEGINS: "THIRDS/SMART_WIFI_MANAGEMENT_BEGINS",
  SMART_WIFI_MANAGEMENT_SUCCESS: "THIRDS/SMART_WIFI_MANAGEMENT_SUCCESS",
  SMART_WIFI_MANAGEMENT_FAILURE: "THIRDS/SMART_WIFI_MANAGEMENT_FAILURE",

  /* GET GAME PASS CODE */
  GET_GAME_PASS_CODE: "THIRDS/GET_GAME_PASS_CODE",
  SET_GAME_PASS_CODE: "THIRDS/SET_GAME_PASS_CODE",

  /* GET PROMO CODES */
  GET_PROMO_CODES: "THIRDS/GET_PROMO_CODES_BEGINS",
  SET_PROMO_CODES: "THIRDS/SET_PROMO_CODES",
};

export const actions = {
  // Actions for ThirdServices
  getListThirdParties: () => ({ type: types.GET_THIRDSERVICES_BEGINS }),
  successGetListThirdParties: (data) => ({
    type: types.GET_THIRDSERVICES_SUCCESS,
    payload: data,
  }),
  successGetListThirdParties2: (list, svaCarousel) => ({
    type: types.GET_THIRDSERVICES_SUCCESS2,
    payload: { list, svaCarousel },
  }),
  failureGetListThirdParties: (error) => ({
    type: types.GET_THIRDSERVICES_FAILURE,
    payload: error,
  }),
  // Actions for delete a ThirdService
  resetDeleteThirdParties: () => ({
    type: types.DELETE_THIRDSERVICES_RESET,
  }),
  deleteThirdParties: (thirdPartiesObj) => ({
    type: types.DELETE_THIRDSERVICES_BEGINS,
    thirdPartiesObj,
  }),
  deleteThirdPartiesSuccess: (data) => ({
    type: types.DELETE_THIRDSERVICES_SUCCESS,
    payload: data,
  }),
  deleteThirdPartiesFailure: (error) => ({
    type: types.DELETE_THIRDSERVICES_FAILURE,
    error,
  }),
  // Actions for add a ThirdService
  addThirdPartie: (thirdPartieObj) => ({
    type: types.ADD_THIRDSERVICES_BEGINS,
    thirdPartieObj,
  }),
  addThirdPartieSuccess: (data) => ({
    type: types.ADD_THIRDSERVICES_SUCCESS,
    payload: data,
  }),
  addThirdPartieFailure: (error) => ({
    type: types.ADD_THIRDSERVICES_FAILURE,
    error,
  }),
  resetThirdParty: () => ({ type: types.THIRDSERVICES_RESET }),

  // secure connection redirect
  goToSecureConnectionPage: () => ({ type: types.GOTO_CS_PAGE_BEGINS }),
  goToSecureConnectionPageSuccess: () => ({ type: types.GOTO_CS_PAGE_SUCCESS }),
  goToSecureConnectionPageFailure: () => ({ type: types.GOTO_CS_PAGE_FAILURE }),
  // Actions for Netflix
  getUrlActivateNetflix: (administrativeNumber) => ({
    type: types.GET_NETFLIX_BEGINS,
    administrativeNumber,
  }),
  successGetActivateNetflix: (data) => ({
    type: types.GET_NETFLIX_SUCCESS,
    payload: data,
  }),
  failureGetActivateNetflix: (error) => ({
    type: types.GET_NETFLIX_FAILURE,
    payload: error,
  }),
  changeNetflixState: (data) => ({
    type: types.CHANGE_NETFLIX_STATE,
    payload: data,
  }),
  // Actions for Disney
  getCompatibilityDisney: (productId) => ({
    type: types.GET_DISNEY_COMPATIBILITY,
    productId,
  }),
  successGetCompatibilityDisney: (data) => ({
    type: types.GET_DISNEY_COMPATIBILITY_SUCCESS,
    payload: data,
  }),
  failureGetCompatibilityDisney: (error) => ({
    type: types.GET_DISNEY_COMPATIBILITY_FAILURE,
    payload: error,
  }),
  getDisneyActivation: (data) => ({
    type: types.GET_DISNEY_ACTIVATION,
    data,
  }),
  changeStatusGetDisneyActivation: (response) => ({
    type: types.CHANGE_STATUS_DISNEY_ACTIVATION,
    payload: response,
  }),
  // Actions for Alejandra
  goToAlejandra: (phoneNumber) => ({
    type: types.GOTO_ALEJANDRA_PAGE_BEGINS,
    phoneNumber,
  }),
  goToAlejandraSuccess: (data) => ({
    type: types.GOTO_ALEJANDRA_PAGE_SUCCESS,
    payload: data,
  }),
  goToAlejandraFailure: (error) => ({
    type: types.GOTO_ALEJANDRA_PAGE_FAILURE,
    payload: error,
  }),
  // Action to get URL Alejandra
  getUrlAlejandra: ({ productId }) => ({
    type: types.GET_URL_ALEJANDRA_BEGINS,
    productId,
  }),
  getUrlAlejandraSuccess: (data) => ({
    type: types.GET_URL_ALEJANDRA_SUCCESS,
    payload: data,
  }),
  getUrlAlejandraFailure: (error) => ({
    type: types.GET_URL_ALEJANDRA_FAILURE,
    payload: error,
  }),
  // Actions for Provider compatibility
  getProviderCompatibilityData: (data) => ({
    type: types.GET_PROVIDER_COMPATIBILITY_BEGINS,
    payload: data,
  }),
  getNewProviderCompatibilityData: (data) => ({
    type: types.GET_NEW_PROVIDER_COMPATIBILITY_BEGINS,
    payload: data,
  }),
  successGetProviderCompatibilityData: (data) => ({
    type: types.GET_PROVIDER_COMPATIBILITY_SUCCESS,
    payload: data,
  }),
  successGetNewProviderCompatibilityData: (data) => ({
    type: types.GET_NEW_PROVIDER_COMPATIBILITY_SUCCESS,
    payload: data,
  }),
  failureGetProviderCompatibilityData: (error) => ({
    type: types.GET_PROVIDER_COMPATIBILITY_FAILURE,
    payload: error,
  }),
  failureGetNewProviderCompatibilityData: (error) => ({
    type: types.GET_NEW_PROVIDER_COMPATIBILITY_FAILURE,
    payload: error,
  }),
  // Actions for Provider activation
  getProviderStatusData: (provider) => ({
    type: types.GET_PROVIDER_STATUS_BEGINS,
    provider,
  }),
  successGetProviderStatusData: (data, provider) => ({
    type: types.GET_PROVIDER_STATUS_SUCCESS,
    payload: { data, provider },
  }),
  failureGetProviderStatusData: (error) => ({
    type: types.GET_PROVIDER_STATUS_FAILURE,
    payload: error,
  }),
  // Actions for Game Pass activation code
  getGamePassCode: (productId) => ({
    type: types.GET_GAME_PASS_CODE,
    productId,
  }),
  setGamePassCode: (data) => ({
    type: types.SET_GAME_PASS_CODE,
    payload: data,
  }),
  // SMART WIFI DEVICES
  getSmartWiFiDevices: ({ phoneNumber, productId }) => ({
    type: types.GET_SMART_WIFI_DEVICES_BEGINS,
    phoneNumber,
    productId,
  }),
  successGetSmartWiFiDevices: (data) => ({
    type: types.GET_SMART_WIFI_DEVICES_SUCCESS,
    payload: data,
  }),
  failureGetSmartWiFiDevices: (data) => ({
    type: types.GET_SMART_WIFI_DEVICES_FAILURE,
    payload: data,
  }),
  // SMART WIFI OTHER DETAILS
  getSmartWiFiOthersDetails: (data) => ({
    type: types.GET_SMART_WIFI_OTHERS_DETAILS_BEGINS,
    data,
  }),
  successGetSmartWiFiOthersDetails: (data) => ({
    type: types.GET_SMART_WIFI_OTHERS_DETAILS_SUCCESS,
    payload: data,
  }),
  failureGetSmartWiFiOthersDetails: () => ({
    type: types.GET_SMART_WIFI_OTHERS_DETAILS_FAILURE,
  }),
  // SMART WIFI MANAGEMENT
  smartWiFiManagement: (data) => ({
    type: types.SMART_WIFI_MANAGEMENT_BEGINS,
    payload: { ...data },
  }),
  successSmartWiFiManagement: (data) => ({
    type: types.SMART_WIFI_MANAGEMENT_SUCCESS,
    payload: { ...data },
  }),
  failureSmartWiFiManagement: (data) => ({
    type: types.SMART_WIFI_MANAGEMENT_FAILURE,
    payload: { ...data },
  }),

  // Actions for get promo codes
  getPromoCodes: (data) => ({
    type: types.GET_PROMO_CODES,
    data,
  }),
  setPromoCodes: (data) => ({
    type: types.SET_PROMO_CODES,
    payload: data,
  }),
};

const initialState = {
  // THIRD SERVICES LIST
  listThirdServices: [],
  listThirdServicesError: null,
  listThirdServicesFetching: false,
  listThirdServicesFetched: false,
  /* ppma code */
  thirdServices: null,
  svaCarousel: null,
  catalog: null,

  // THIRD SERVICES DELETE
  deleteThirdServices: null,
  deleteThirdServicesError: false,
  deleteThirdServicesFetching: false,
  deleteThirdServicesErrorExpected: null,
  // THIRD SERVICES ADD
  addThirdServices: null,
  addThirdServicesError: false,
  addThirdServicesFetching: false,
  addThirdServicesErrorExpected: null,
  // CLIENT DATA
  secureConnection: {
    fetching: false,
    redirect: false,
    error: false,
    url: null,
  },
  // NETFLIX
  netflixUrlActivation: null,
  netflixUrlActivacionError: false,
  netflixUrlActivationFetching: false,
  // DISNEY COMPATIBILITY
  disneyCompatibility: null,
  disneyStatus: null,
  disneyFetching: false,
  disneyActivation: null,
  // GO TO ALEJANDRA
  alejandra: {
    fetching: false,
    redirect: false,
    error: false,
    url: null,
  },
  // GET URL ALEJANDRA
  urlAlejandra: [],
  urlAlejandraError: false,
  urlAlejandraFetching: false,
  // GET PROVIDER COMPATIBILITY
  providerCompatibility: null,
  providerCompatibilityFetching: false,
  providerCompatibilityError: false,
  addOnIncluded: [],
  addOnContrated: [],
  // GET PROVIDER STATUS
  providerStatus: null,
  providerStatusFetching: false,
  providerStatusError: false,
  // GET GAME PASS ACTIVATION CODE
  getGamePassCode: { data: null, fetching: null, error: null },
  // SMART WIFI DEVICES
  smartWiFiDevicesFetching: false,
  smartWiFiDevices: null,
  smartWiFiDevicesError: false,
  smartWiFiDevicesFetched: false,
  // SMART WIFI OTHERS DETAILS
  smartWiFiOthersDetailsFetching: false,
  smartWiFiOthersDetails: null,
  smartWiFiOthersDetailsError: false,

  // PROMO CODES
  promoCodes: {
    data: null,
    fetching: false,
    error: false,
  },
};

function reducer(state = { ...initialState }, { type, payload, error }) {
  switch (type) {
    case HYDRATE: {
      const { thirdParties } = payload;
      return {
        ...state,
        ...thirdParties,
      };
    }
    case USER_UPGRADE_CLEAR:
      return initialState;
    case types.GET_THIRDSERVICES_BEGINS:
      return {
        ...state,
        listThirdServicesFetched: false,
        listThirdServicesFetching: true,
        listThirdServicesError: false,
        listThirdServices: [],
      };
    case types.GET_THIRDSERVICES_SUCCESS:
      return {
        ...state,
        listThirdServices: payload,
        listThirdServicesFetching: false,
        listThirdServicesError: false,
        listThirdServicesFetched: true,
      };
    case types.GET_THIRDSERVICES_SUCCESS2: {
      const { list } = payload;
      const { thirdpartiesNormalized, svaCarousel, thirdServicesInfo } = list;
      return {
        ...state,
        svaCarousel,
        listThirdServices: thirdServicesInfo.splice(0, 999),
        thirdServices: thirdpartiesNormalized,
        listThirdServicesFetching: false,
        listThirdServicesError: false,
        listThirdServicesFetched: true,
      };
    }

    case types.GET_THIRDSERVICES_FAILURE:
      return {
        ...state,
        listThirdServicesFetching: false,
        listThirdServicesFetched: false,
        listThirdServicesError: payload,
      };
    case types.DELETE_THIRDSERVICES_RESET:
      return {
        ...state,
        deleteThirdServices: null,
        deleteThirdServicesError: false,
        deleteThirdServicesFetching: false,
        deleteThirdServicesErrorExpected: null,
      };
    case types.DELETE_THIRDSERVICES_BEGINS:
      return {
        ...state,
        deleteThirdServicesFetching: true,
        deleteThirdServicesError: false,
        deleteThirdServicesErrorExpected: null,
      };
    case types.DELETE_THIRDSERVICES_SUCCESS:
      return {
        ...state,
        deleteThirdServices: payload,
        deleteThirdServicesFetching: false,
        deleteThirdServicesError: false,
        deleteThirdServicesErrorExpected: null,
      };
    case types.DELETE_THIRDSERVICES_FAILURE: {
      const deleteThirdServicesErrorExpected = error;
      return {
        ...state,
        deleteThirdServices: null,
        deleteThirdServicesFetching: false,
        deleteThirdServicesError: true,
        deleteThirdServicesErrorExpected,
      };
    }
    case types.ADD_THIRDSERVICES_BEGINS:
      return {
        ...state,
        addThirdServicesFetching: true,
        addThirdServicesError: false,
        addThirdServicesErrorExpected: null,
      };
    case types.ADD_THIRDSERVICES_SUCCESS:
      return {
        ...state,
        addThirdServices: payload,
        addThirdServicesFetching: false,
        addThirdServicesErrorExpected: null,
      };
    case types.ADD_THIRDSERVICES_FAILURE: {
      const addThirdServicesErrorExpected = error;
      return {
        ...state,
        addThirdServices: null,
        addThirdServicesFetching: false,
        addThirdServicesError: true,
        addThirdServicesErrorExpected,
      };
    }
    case types.THIRDSERVICES_RESET:
      return {
        ...state,
        addThirdServices: null,
        addThirdServicesFetching: false,
        addThirdServicesError: false,
        addThirdServicesErrorExpected: null,
        deleteThirdServices: null,
        deleteThirdServicesFetching: false,
        deleteThirdServicesError: false,
        deleteThirdServicesErrorExpected: null,
      };
    case types.GOTO_CS_PAGE_BEGINS:
      return {
        ...state,
        secureConnection: {
          ...state.secureConnection,
          fetching: true,
        },
      };
    case types.GOTO_CS_PAGE_SUCCESS: {
      return {
        ...state,
        secureConnection: {
          ...state.secureConnection,
          fetching: false,
          redirect: true,
        },
      };
    }
    case types.GOTO_CS_PAGE_FAILURE:
      return {
        ...state,
        secureConnection: {
          ...state.secureConnection,
          fetching: false,
          error: true,
        },
      };
    case types.GET_NETFLIX_BEGINS:
      return {
        ...state,
        netflixUrlActivationFetching: true,
        netflixUrlActivacionError: false,
      };
    case types.GET_NETFLIX_SUCCESS: {
      const netflixUrlActivationBefore = state.netflixUrlActivation || [];
      const newNetflixUrlActivation = [
        ...netflixUrlActivationBefore,
        { ...payload },
      ];

      return {
        ...state,
        netflixUrlActivation: newNetflixUrlActivation,
        netflixUrlActivationFetching: false,
        netflixUrlActivacionError: false,
      };
    }
    case types.GET_NETFLIX_FAILURE:
      return {
        ...state,
        netflixUrlActivationFetching: false,
        netflixUrlActivacionError: payload,
      };
    case types.CHANGE_NETFLIX_STATE:
      return {
        ...state,
        netflixUrlActivationFetching: payload,
      };
    case types.GET_DISNEY_COMPATIBILITY: {
      return {
        ...state,
        disneyFetching: true,
      };
    }
    case types.GET_DISNEY_COMPATIBILITY_SUCCESS: {
      const compatibles = payload;
      return {
        ...state,
        disneyCompatibility: compatibles,
        disneyFetching: false,
      };
    }
    case types.GET_DISNEY_COMPATIBILITY_FAILURE:
      return {
        ...state,
        disneyCompatibilityError: payload,
      };
    case types.GET_DISNEY_ACTIVATION:
      return {
        ...state,
        disneyActivation: { url: null, fetching: true, error: false },
      };
    case types.CHANGE_STATUS_DISNEY_ACTIVATION:
      return {
        ...state,
        disneyActivation: payload,
      };
    case types.GOTO_ALEJANDRA_PAGE_BEGINS:
      return {
        ...state,
        alejandra: {
          ...state.alejandra,
          fetching: true,
        },
      };
    case types.GOTO_ALEJANDRA_PAGE_SUCCESS:
      return {
        ...state,
        alejandra: {
          ...state.alejandra,
          fetching: false,
          redirect: true,
        },
      };
    case types.GOTO_ALEJANDRA_PAGE_FAILURE:
      return {
        ...state,
        alejandra: {
          ...state.alejandra,
          fetching: false,
          error: true,
        },
      };
    case types.GET_URL_ALEJANDRA_BEGINS:
      return {
        ...state,
        urlAlejandraFetching: false,
        urlAlejandraError: false,
      };
    case types.GET_URL_ALEJANDRA_SUCCESS: {
      const alejandraUrlBefore = state.urlAlejandra;
      const newAlejandraUrl = [...alejandraUrlBefore, { ...payload }];
      return {
        ...state,
        urlAlejandra: newAlejandraUrl,
        urlAlejandraFetching: false,
        netflixUrlActivationError: false,
      };
    }
    case types.GET_URL_ALEJANDRA_FAILURE:
      return {
        ...state,
        urlAlejandraFetching: false,
        urlAlejandraError: payload,
      };
    // GET PROVIDER COMPATIBILITY
    case types.GET_PROVIDER_COMPATIBILITY_BEGINS: {
      let providerCompatibility = {
        ...state.providerCompatibility,
      };
      providerCompatibility[payload.provider] = {
        fetching: true,
      };

      return {
        ...state,
        providerCompatibility: providerCompatibility,
        providerCompatibilityFetching: true,
        providerCompatibilityError: null,
      };
    }
    case types.GET_PROVIDER_COMPATIBILITY_SUCCESS: {
      const { data, provider } = payload
      let newModule = {
        ...state.providerCompatibility,
      };
      let addOnIncludedArray = state.addOnIncluded;
      let addOnContratedArray = state.addOnContrated;

      newModule[payload.provider] = payload.data;

      if (data?.compatibles?.[0]?.compatibilidad === true) {
        const newProvider = createProviderObject(data, provider);
        if (data?.compatibles?.[0]?.addOn && !addOnContratedArray.find((item) => item?.id === provider)) {
          addOnContratedArray.push(newProvider);
        } else if (!addOnContratedArray.find((item) => item?.id === provider) 
          && !addOnIncludedArray.find((item) => item?.id === provider)) {
          addOnIncludedArray.push(newProvider)
        }
      }

      return {
        ...state,
        providerCompatibility: newModule,
        providerCompatibilityFetching: false,
        providerCompatibilityError: null,
        addOnIncluded: addOnIncludedArray && removeDuplicateCardsById(addOnIncludedArray),
        addOnContrated: addOnContratedArray && removeDuplicateCardsById(addOnContratedArray),
      };
    }
    case types.GET_PROVIDER_COMPATIBILITY_FAILURE: {
      return {
        ...state,
        providerCompatibilityFetching: false,
        providerCompatibilityError: payload,
      };
    }

    // GET PROVIDER COMPATIBILITY CAPA
    case types.GET_NEW_PROVIDER_COMPATIBILITY_BEGINS: {
      let providerCompatibility = {
        ...state.providerCompatibility,
      };
      providerCompatibility[payload.provider] = {
        fetching: true,
      };

      return {
        ...state,
        providerCompatibility: providerCompatibility,
        providerCompatibilityFetching: true,
        providerCompatibilityError: null,
      };
    }
    case types.GET_NEW_PROVIDER_COMPATIBILITY_SUCCESS: {
      let newModule = {
        ...state.providerCompatibility,
      };
      let addOnIncludedArray = state.addOnIncluded;
      let addOnContratedArray = state.addOnContrated;

      newModule[payload.provider] = payload.data;

      if (payload?.data?.compatibles?.[0]?.compatibilidad === true) {
        const newProvider = createProviderObject(payload?.data, payload?.provider);
        if (payload?.data?.compatibles?.[0]?.addOn && !addOnContratedArray.find((item) => item?.id === provider)) {
          addOnContratedArray.push(newProvider);
        } else if (!addOnContratedArray.find((item) => item?.id === provider) 
          && !addOnIncludedArray.find((item) => item?.id === provider)) {
          addOnIncludedArray.push(newProvider)
        }
      } else if (payload?.data?.compatible === true) {
        const newProvider = createProviderObject(payload?.data, payload?.provider);
        addOnIncludedArray.push(newProvider)
      }

      return {
        ...state,
        providerCompatibility: newModule,
        providerCompatibilityFetching: false,
        providerCompatibilityError: null,
        addOnIncluded: addOnIncludedArray && removeDuplicateCardsById(addOnIncludedArray),
        addOnContrated: addOnContratedArray && removeDuplicateCardsById(addOnContratedArray),
      };
    }
    case types.GET_NEW_PROVIDER_COMPATIBILITY_FAILURE: {
      return {
        ...state,
        providerCompatibilityFetching: false,
        providerCompatibilityError: payload,
      };
    }

    // GET PROVIDER STATUS
    case types.GET_PROVIDER_STATUS_BEGINS: {
      return {
        ...state,
        providerStatusFetching: true,
        providerStatusError: null,
      };
    }
    case types.GET_PROVIDER_STATUS_SUCCESS: {
      const { provider, data } = payload;
      const lastDataProviderStatus = {
        ...state.providerStatus,
      };
      const lastKeys = Object.keys(lastDataProviderStatus);
      const exist = lastKeys.find((elem) => elem === provider);
      if (!exist) {
        lastDataProviderStatus[provider] = data;
      }
      return {
        ...state,
        providerStatus: lastDataProviderStatus,
        providerStatusFetching: false,
        providerStatusError: null,
      };
    }
    case types.GET_PROVIDER_STATUS_FAILURE: {
      return {
        ...state,
        providerStatusFetching: false,
        providerStatusError: payload,
      };
    }

    // GET GAME PASS ACTIVATION CODE
    case types.GET_GAME_PASS_CODE: {
      return {
        ...state,
        getGamePassCode: {
          data: null,
          fetching: true,
          error: false,
        },
      };
    }
    case types.SET_GAME_PASS_CODE: {
      return {
        ...state,
        getGamePassCode: payload,
      };
    }
    // SMART WIFI DEVICES
    case types.GET_SMART_WIFI_DEVICES_BEGINS: {
      const { telefono: phone } = { ...payload };
      return {
        ...state,
        smartWiFiDevices: {
          ...state.smartWiFiDevices,
          [phone]: {
            smartWiFiDevicesError: false,
            smartWiFiDevicesFetching: true,
          },
        },
        smartWiFiDevicesFetched: false,
      };
    }
    case types.GET_SMART_WIFI_DEVICES_SUCCESS: {
      const { phone, data } = { ...payload };
      return {
        ...state,
        smartWiFiDevices: {
          ...state.smartWiFiDevices,
          [phone]: {
            ...data,
            smartWiFiDevicesError: false,
            smartWiFiDevicesFetching: false,
          },
        },
        smartWiFiDevicesFetched: true,
      };
    }
    case types.GET_SMART_WIFI_DEVICES_FAILURE: {
      const { phone } = { ...payload };
      return {
        ...state,
        smartWiFiDevices: {
          ...state.smartWiFiDevices,
          [phone]: {
            smartWiFiDevicesError: true,
            smartWiFiDevicesFetching: false,
          },
        },
        smartWiFiDevicesFetched: true,
      };
    }
    // SMART WIFI OTHERS DETAILS
    case types.GET_SMART_WIFI_OTHERS_DETAILS_BEGINS:
      return {
        ...state,
        smartWiFiOthersDetailsFetching: true,
        smartWiFiOthersDetailsError: false,
      };
    case types.GET_SMART_WIFI_OTHERS_DETAILS_SUCCESS: {
      return {
        ...state,
        smartWiFiOthersDetails: payload,
        smartWiFiOthersDetailsError: false,
        smartWiFiOthersDetailsFetching: false,
      };
    }
    case types.GET_SMART_WIFI_OTHERS_DETAILS_FAILURE:
      return {
        ...state,
        smartWiFiOthersDetailsFetching: false,
        smartWiFiOthersDetailsError: true,
      };
    // SMART WIFI MANAGEMENT
    case types.SMART_WIFI_MANAGEMENT_BEGINS: {
      const { deviceData, line } = { ...payload };
      return {
        ...state,
        smartWiFiDevices: {
          ...state.smartWiFiDevices,
          [line]: {
            ...state.smartWiFiDevices[line],
            devices: {
              ...state.smartWiFiDevices[line].devices,
              [deviceData.device_id]: {
                ...state.smartWiFiDevices[line].devices[deviceData.device_id],
                fetching: true,
                error: false,
              },
            },
          },
        },
      };
    }
    case types.SMART_WIFI_MANAGEMENT_SUCCESS: {
      const { deviceData, line } = { ...payload };
      return {
        ...state,
        smartWiFiDevices: {
          ...state.smartWiFiDevices,
          [line]: {
            ...state.smartWiFiDevices[line],
            devices: {
              ...state.smartWiFiDevices.devices,
              [deviceData.device_id]: {
                ...state.smartWiFiDevices[line].devices[deviceData.device_id],
                fetching: false,
                error: false,
                pausado:
                  !state.smartWiFiDevices[line].devices[deviceData.device_id]
                    .pausado,
              },
            },
          },
        },
      };
    }
    case types.SMART_WIFI_MANAGEMENT_FAILURE: {
      const { deviceData, line } = { ...payload };
      return {
        ...state,
        smartWiFiDevices: {
          ...state.smartWiFiDevices,
          [line]: {
            ...state.smartWiFiDevices[line],
            devices: {
              ...state.smartWiFiDevices[line].devices,
              [deviceData.device_id]: {
                ...state.smartWiFiDevices[line].devices[deviceData.device_id],
                fetching: false,
                error: true,
              },
            },
          },
        },
      };
    }
    case types.GET_PROMO_CODES:
      return {
        ...state,
        promoCodes: { data: null, fetching: true, error: false },
      };
    case types.SET_PROMO_CODES:
      return {
        ...state,
        promoCodes: payload,
      };
    default:
      return state;
  }
}

export default reducer;
